import {
  ContactPersonToContractsService,
  type ContactPersonToContractV1Dto,
  type CreateContactPersonToContractV1Dto,
  PatchContactPersonToContractV1Dto,
} from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { ContactPersonToContractSimple } from '../contactTypes';

export function useContactPersonToContract() {
  const createContactPersonToContract = async (data: CreateContactPersonToContractV1Dto) => {
    try {
      await ContactPersonToContractsService.contactPersonToContractControllerV1CreateV1(data);
      eventBus.emit('create');
    } catch (err) {
      console.log(err);
    }
  };

  const updateContactPersonToContract = async (
    id: string,
    data: PatchContactPersonToContractV1Dto,
  ) => {
    try {
      await ContactPersonToContractsService.contactPersonToContractControllerV1UpdatePartialV1(
        id,
        data,
      );
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const fetchContactPersonToContract = async (id: string) => {
    try {
      return await ContactPersonToContractsService.contactPersonToContractControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteContactPersonToContract = async (ids: string[]) => {
    try {
      await ContactPersonToContractsService.contactPersonToContractControllerV1RemoveManyV1({
        values: ids,
      });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchContactPersonToContract,
    updateContactPersonToContract,
    createContactPersonToContract,
    deleteContactPersonToContract,
  };
}

export function useContactPersonsToContractConverter() {
  const convertContactPersonToContractDtoToContactPersonToContractSimple = (
    item: ContactPersonToContractV1Dto,
  ): ContactPersonToContractSimple => {
    const { createdAt: _createdAt, modifiedAt: _modifiedAt, ...res } = item;
    return { ...res };
  };

  const convertContactPersonToContractDtoListToContactPersonToContractSimpleList = (
    data: ContactPersonToContractV1Dto[],
  ): ContactPersonToContractSimple[] => {
    return data.map((item) => {
      return convertContactPersonToContractDtoToContactPersonToContractSimple(item);
    });
  };
  return { convertContactPersonToContractDtoListToContactPersonToContractSimpleList };
}
